if (!customElements.get('frozen-cart-status')) {
  // Mirrors the Liquid-rendered frozen shipping state (snippets/frozen-shipping.liquid) onto checkout
  // controls that are not part of the re-rendered cart markup. Contains no weight or validation logic:
  // every value is read from data attributes. Runs once per insertion, so section re-renders keep it in sync.
  const lastStates = {};

  customElements.define(
    'frozen-cart-status',
    class FrozenCartStatus extends HTMLElement {
      connectedCallback() {
        const scope = this.dataset.scope;
        const root = scope === 'drawer' ? this.closest('cart-drawer') : document.getElementById('main-cart-footer');

        if (root) this.syncCheckout(root);
        this.announce(scope);
      }

      syncCheckout(root) {
        const blocked = this.dataset.checkoutBlocked === 'true';

        root.querySelectorAll('[data-frozen-checkout]').forEach((button) => {
          if (blocked) {
            button.disabled = true;
            button.setAttribute('data-frozen-disabled', '');
            button.setAttribute('aria-describedby', this.dataset.messageId);
            button.textContent = this.dataset.blockedLabel;
          } else if (button.hasAttribute('data-frozen-disabled')) {
            button.disabled = false;
            button.removeAttribute('data-frozen-disabled');
            button.removeAttribute('aria-describedby');
            button.textContent = button.dataset.labelDefault;
          }
        });

        root.querySelectorAll('[data-frozen-express]').forEach((wrapper) => {
          wrapper.hidden = blocked;
        });
      }

      announce(scope) {
        const state = this.dataset.state;
        const previousState = lastStates[scope];
        lastStates[scope] = state;

        if (previousState === undefined || previousState === state) return;

        const liveRegion = document.getElementById('FrozenShipping-LiveRegion');
        if (!liveRegion) return;

        liveRegion.textContent = '';
        requestAnimationFrame(() => {
          liveRegion.textContent = this.dataset.announcement;
        });
      }
    }
  );
}
